module.exports = __webpack_public_path__ + "static/media/medax_logo.4b67c983.png";